<script>
    import IconPlus from '@/components/icon/IconPlus.vue';
    import { releaseAndUnreleaseFile } from '@/api/file.js';

    export default {
        components: {
            IconPlus: IconPlus,
        },
        methods: {
            async releaseAllFile() {
                let fileListID = [];
                let fileList = this.$store.getters.IMAGES;
                fileList.forEach((fileValue, fileIndex) => {
                    if (fileValue.isActive === true) fileListID.push(fileValue.id);
                });

                if (fileListID.length > 0) {
                    const response = await releaseAndUnreleaseFile(
                        await this.$store.getters.ASSET_TYPE_IMAGES,
                        fileListID
                    );

                    if (response === true) {
                        fileList.forEach(async (fileValue, fileIndex) => {
                            await fileValue.setReleaseStatus(true);
                        });
                    }
                }
            }
        }
    }
</script>


<template>
    <button 
        class="left_button_main_container"
        @click="releaseAllFile"    
    >
        <div class="left_button_icon_container">
            <IconPlus 
                icon-height="16px"
                icon-width="16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Release All</label>
        </div>
    </button>
</template>